<template lang="pug">
div
  UiCardSection
    UiCard(
      shadow="never"
      border="always"
    )
      UiCardSection
        h4 {{ $t("companies.reports.scheduled_reports") }}
        RestTable(
          namespace="report_types"
          :headers="type_headers"
          ref="scheduledReportTypesTable"
          :fetch-handler="getScheduledReportTypes"
          embed
        )
          template(#cell:schedule="{ item }")
            span {{ item.schedule }}
          template(#cell:actions="{ item }")
            UiButton(
              size="sm"
              variant="smooth-danger"
              @click="deleteReport(item)"
              v-if="item.status != 'started'"
              icon="Trash"
            ) {{ $t("actions.delete") }}

  UiCardSection
    UiCard(
      shadow="never"
      border="always"
    )
      UiCardSection
        h4 {{ $t("companies.reports.scheduled_reports_runned") }}
        RestTable(
          namespace="reports_scheduled"
          :headers="headers"
          ref="reportsTable"
          :fetch-handler="getData"
          embed
        )
          template(#cell:status="{ item }")
            ReportStatuses(
              :item="item"
              @show="showReport(item)"
            )
          template(#cell:name="{ item }")
            task-name(:item="item")
          template(#cell:actions="{ item }")
            UiStack(spacing="xs")
              UiButton(
                size="sm"
                variant="smooth-danger"
                @click="deleteReport(item)"
                v-if="item.status != 'started'"
                icon="Trash"
              ) {{ $t("actions.delete") }}
              UiButton(
                size="sm"
                variant="smooth-warning"
                @click="restartJob(item)"
                v-if="item.status == 'error'"
                icon="RefreshCw"
              ) {{ $t("companies.reports.restart") }}
              UiButton(
                size="sm"
                variant="smooth-warning"
                @click="editReport(item)"
                v-if="(item.status == 'error') & ['twin_treasury_file', 'netvisor_opus_voucher', 'netvisor_importer_payment'].includes(item.report_type)"
                icon="PencilCreate"
              ) {{ $t("actions.edit") }}

  CreateReportModal(
    ref="CreateReportModal"
    @done="reloadList"
  )
  ShowReportModal(ref="ShowReportModal")
</template>

<script>
import ApiCompanyReports from "@/api/companyReports.js";
import ApiCompanies from "@/api/companies.js";
import CreateReportModal from "@/modals/Companies/createReport.vue";
import ShowReportModal from "@/modals/Companies/showReport.vue";
import TaskName from "@/views/Tasks/taskName.vue";
import ReportStatuses from "../Companies/Tabs/reports/ReportStatuses.vue";

export default {
  components: {
    CreateReportModal,
    ShowReportModal,
    TaskName,
    ReportStatuses,
  },

  data() {
    return {
      company: {},
      total_types: 0,
      type_headers: [
        {
          key: "report_type_name",
          label: "Type",
          sortable: true,
        },
        {
          key: "schedule",
          label: "Schedule",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
      headers: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "report_type_name",
          label: "Type",
          sortable: true,
        },
        {
          key: "software_name",
          label: "Software",
        },
        {
          key: "name",
          label: "File name",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Created at",
          sortable: true,
        },
        {
          key: "end_at",
          label: "End at",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },
  methods: {
    reloadList() {
      this.$refs.reportsTable.fetchData();
      this.$refs.scheduledReportTypesTable.fetchData();
    },

    getScheduledReportTypes(params, config) {
      return ApiCompanyReports.fetchScheduledReportTypes(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        this.total_types = resp.data.meta.total_count;
        return {
          items: resp.data.reports,
          meta: resp.data.meta,
        };
      });
    },

    getData(params, config) {
      return ApiCompanyReports.fetchScheduledReports(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.reports,
          meta: resp.data.meta,
        };
      });
    },

    showReport(item) {
      this.$refs.ShowReportModal.open(item);
    },

    addReport() {
      this.$refs.CreateReportModal.open(this.$route.params.id, null);
    },

    editReport(item) {
      this.$refs.CreateReportModal.open(this.$route.params.id, item);
    },

    deleteReport(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "briefcase-remove",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanyReports.deleteReport(this.$route.params.id, item.id).then(
          (resp) => {
            this.reloadList();
          },
        );
      });
    },
    downloadReport(item) {
      ApiCompanyReports.downloadReport(this.$route.params.id, item.id)
        .then((resp) => {
          let filename = resp.headers["content-disposition"]
            .split(";")
            .find((n) => n.includes("filename="))
            .replace("filename=", "")
            .trim();
          let fileURL = window.URL.createObjectURL(
            new Blob([resp.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
          );
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", filename);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
    fetchCompany() {
      ApiCompanies.getCompany(this.$route.params.id).then((resp) => {
        this.company = resp.data.company;
      });
    },
    restartJob(item) {
      ApiCompanyReports.restartReport(this.$route.params.id, item.id).then(
        (resp) => {
          this.reloadList();
        },
      );
    },
  },
  created() {
    this.fetchCompany();
  },
};
</script>
